<template>
  <div class="requirements-lists">
    <div v-for="cardType in typesByCards" :key="cardType.id" class="requirements-list">
      <div
        class="add-requirement-type-card add-requirement-type-card-empty"
        :class="{
          'add-requirement-type-card-disabled': !event || isCardTypeDisabled(cardType, cardsByTypes)
        }"
      >
        <v-tooltip location="top" open-delay="100" max-width="300" :disabled="!event">
          <template v-slot:activator="{ props }">
            <div v-bind="props" class="add-requirement-type-card-plus-button-wrapper">
              <v-btn
                size="small"
                icon="mds:add"
                :disabled="$store.state.isWorkflowDisabled"
                class="add-requirement-type-card-plus-button"
                :style="'background-color:' + getBackgroundColour(cardType)"
                @click="callFnIfNotDisabled(cardType,()=>submitCardForm(event.id, cardType.id, '<p>New card</p>'))"
              />
            </div>
          </template>
          {{ isCardTypeDisabled(cardType, cardsByTypes) ? 'Use max 1 card of type ' + cardType.title + ' per event.' : 'Add one card' }}
        </v-tooltip>
        <h4 class="add-requirement-type-card-title text-truncate">
          {{ cardType.title }}
          {{ (cardsByTypes[cardType.id]?.length > 2) ? '(' + cardsByTypes[cardType.id].length + ')' : '' }}
        </h4>
        <v-spacer class="add-requirement-type-card-spacer"/>
        <v-tooltip location="top" open-delay="100" :disabled="!event">
          <template v-slot:activator="{ props }">
            <div v-bind="props" class="add-requirement-type-card-ask-ai-button-wrapper">
              <v-btn
                icon="mds:temp-preferences-custom"
                size="small"
                :disabled="$store.state.isWorkflowDisabled"
                class="add-requirement-type-card-ask-ai-button"
                @click="callFnIfNotDisabled(cardType, ()=>$emit('add-card-ai', event.id, cardType.id))"
              />
            </div>
          </template>

          {{ isCardTypeDisabled(cardType, cardsByTypes) ? 'Use max 1 card of type ' + cardType.title + ' per event.' : 'Add one card with AI' }}
        </v-tooltip>
      </div>

      <draggable
        v-model="cardsByTypes[cardType.id]"
        group="drop-target"
        :data-type-id="cardType.id"
        :disabled="$store.state.isWorkflowDisabled || isCardTypeDisabled(cardType, cardsByTypes)"
        :sort="true"
        @add="onDraggableAdd($event)"
        @update="onDraggableUpdate(cardType.id, $event)"
      >
        <requirement-description
          v-for="(item, index) in listCards(cardType.id)"
          class="mb-6"
          :class="{'focused': item.id === focusCard}"
          :data-card-id="item.id"
          :key="item.id"
          :item="item"
          :event="event"
          :showAi="true"
          :show-as-invisible="isCardTypeDisabled(cardType, cardsByTypes) && index > 0"
          :hideReplies="true"
          :show-comments-count="true"
          :showEntitySelector="true"
          :expandOnHover="true"
          compact-replies
          hideOpenInSidebar
          @keydown.stop=""
          @ask-for-reply="onAskForReply"
          @open-replies="$emit('show-comments', { card: item, index: index + 1 })"
        >
          <requirement-card-description-field
            :item="item"
            :focus-card="focusCard"
            @move-focus="moveFocus"
            :scrollIntoViewArg="false"
          ></requirement-card-description-field>
        </requirement-description>
      </draggable>
      <div
        v-if="!showMoreByType[cardType.id] && cardsByTypes[cardType.id]?.length > 2"
        class="d-flex justify-end mb-6"
        style="cursor: pointer;"
        @click="showMoreByType[cardType.id] = true"
      >
        <span class="pt-1">Show more</span> <v-icon>mds:keyboard_double_arrow_down</v-icon>
      </div>
      <div
        v-if="showMoreByType[cardType.id] && cardsByTypes[cardType.id]?.length > 2"
        class="d-flex justify-end mb-6"
        style="cursor: pointer;"
        @click="showMoreByType[cardType.id] = false"
      >
        <span class="pt-1">Show less</span> <v-icon>mds:keyboard_double_arrow_up</v-icon>
      </div>
    </div>
  </div>
</template>

<script>
import { VueDraggableNext } from 'vue-draggable-next'
import workflowApi from '@/api/workflowApi'
import cardHelpers from '@/helpers/cardHelpers'
import { EventBus } from '@/event-bus/event-bus.js'
import requirementTypesApi from '@/api/requirementTypesApi'
import RequirementDescription from '@/components/RequirementDescription'
import RequirementCardDescriptionField from '@/components/RequirementCardDescriptionField'
import { diagramHelpers } from '@/mixins/diagramHelpers'
import { mapState } from 'vuex'

export default {
  mixins: [diagramHelpers],
  components: {
    draggable: VueDraggableNext,
    RequirementDescription,
    RequirementCardDescriptionField
  },

  props: {
    typesToDisplayInDiagram: Array,
    event: Object,
    cards: {
      type: Array,
      default () {
        return []
      }
    },
    showDone: Boolean
  },

  data () {
    return {
      showMoreByType: {},
      dialogOpen: false,
      pinDialog: false,
      cardsByTypes: {},
      showComments: null,
      textAreaFormLoading: false,
      focusCard: null,
      timer: null,
      tab: 'cards'
    }
  },

  computed: {
    ...mapState({
      requirementTypes: state => state.requirementTypes.requirementTypes
    }),
    typesByCards () {
      // For now, we can leave this code commented out for future use.

      // const cardTypes = new Set()
      //
      // if (this.event?.requirementsJson) {
      //   this.event.requirementsJson.forEach(({ cardType, done }) => {
      //     if (Boolean(done) === this.showDone && cardType) {
      //       cardTypes.add(cardType.id)
      //     }
      //   })
      // }

      // const groupedTypes = this.typesToDisplayInDiagram.reduce((result, cardType) => {
      //   if (cardTypes.has(cardType.id)) {
      //     result.withCards.push(cardType)
      //   } else {
      //     result.withoutCards.push(cardType)
      //   }
      //
      //   return result
      // }, {
      //   withCards: [],
      //   withoutCards: []
      // })
      // return [...groupedTypes.withCards, ...groupedTypes.withoutCards]

      return this.typesToDisplayInDiagram || []
    },

    attachments () {
      if (!this.event?.requirementsJson) {
        return []
      }

      return this.event.requirementsJson.reduce((acc, { attachments }) => {
        if (attachments) {
          acc.push(...attachments)
        }
        return acc
      }, [])
    }
  },

  watch: {
    cards (newVal) {
      this.computeCardsByType(newVal)
    }
  },

  mounted () {
    this.computeCardsByType(this.cards)
    EventBus.$on('open-card-on-event', item => {
      if (item.eventId === this.event.id) {
        this.dialogOpen = true
        this.pinDialog = true
      }
    })
    EventBus.$on('pin-dialog', item => {
      if (item.eventId === this.event?.id) {
        this.pinDialog = true
      }
    })
  },

  beforeUnmount () {
    EventBus.$off('open-card-on-event')
    EventBus.$off('pin-dialog')
  },

  methods: {
    listCards (cardTypeId) {
      const cards = this.cardsByTypes[cardTypeId] ? [...this.cardsByTypes[cardTypeId]] : []
      if (this.showMoreByType[cardTypeId]) {
        return cards
      }

      return cards.slice(0, 2)
    },
    isCardTypeDisabled (cardType, cardsByTypes) {
      return (cardType.aggregateType || cardType.triggerType) && cardsByTypes?.[cardType?.id]?.length > 0
    },
    pinTheDialog () {
      this.pinDialog = true
    },
    clearTimeout () {
      clearTimeout(this.timer)
    },
    onAskForReply (event) {
      this.$emit('ask-for-reply', Object.assign({}, event, { node: this.event }))
    },
    moveFocus (direction, target) {
      target.firstChild.blur()
    },

    async submitCardForm (eventId, cardTypeId, text) {
      this.textAreaFormLoading = true
      const res = await workflowApi.createRequirementJson(this.$route.params.id, eventId, {
        cardTypeId,
        description: text
      })
      this.showMoreByType[cardTypeId] = true

      this.textAreaFormLoading = false
      if (res?.requirements?.length) {
        this.$nextTick(() => {
          this.focusCard = res.requirements[0].id

          if (res.requirements[0].id && cardTypeId === this.getQueryCardType(this.requirementTypes).id) {
            EventBus.$emit('define-read-model-table', { type: 'example', cardId: res.requirements[0].id })
          }
        })
      }
    },

    getBackgroundColour (cardType) {
      return requirementTypesApi.getBackgroundColour(cardType)
    },

    getTextColour (cardType) {
      return requirementTypesApi.getTextColour(cardType)
    },

    openDialog () {
      this.dialogOpen = true
    },

    onKeyDown (ev) {
      if (ev.keyCode === 27) { // close menu on ESC pressed
        this.dialogOpen = false
        this.pinDialog = false
      }
    },

    onOverlayMouseover () {
      if (!this.pinDialog) {
        this.timer = setTimeout(() => {
          this.dialogOpen = false
        }, 500)
      }
    },

    computeCardsByType (allCards) {
      const typeCards = {}

      if (!allCards) {
        return {}
      }

      // add all types
      this.typesToDisplayInDiagram.forEach(cardType => {
        typeCards[cardType.id] = []
      })

      allCards
        .filter(({ done }) => this.showDone === Boolean(done))
        .forEach(card => {
          const newCard = { ...card }
          newCard.eventId = this.event.id

          const { cardType } = card

          if (!cardType) {
            return
          }

          if (!typeCards[cardType.id]) {
            typeCards[cardType.id] = []
          }

          typeCards[cardType.id].push(newCard)
        })

      Object.values(typeCards).forEach(cards => cardHelpers.sortByReleaseAndSortKey(cards))

      this.cardsByTypes = typeCards
    },

    onDraggableAdd (ev) {
      this.$emit('update-requirement', cardHelpers.moveCard(ev, this.event.requirementsJson, this.cardsByTypes, ev.to.dataset.typeId))
    },

    onDraggableUpdate (cardTypeId, ev) {
      this.$emit('update-requirement', cardHelpers.moveCard(ev, this.event.requirementsJson, this.cardsByTypes, cardTypeId))
    },

    callFnIfNotDisabled (cardType, fn) {
      if (!!this.event && !this.isCardTypeDisabled(cardType, this.cardsByTypes)) {
        fn()
      }
    }
  }
}
</script>

<style scoped>
.add-requirement-type-card {
  display: flex;
  border-radius: 4px;
  align-items: center;
  margin-bottom: 12px;
  background-color: var(--light-1, #FCFCFC);

  .add-requirement-type-card-title {
    font-size: 14px;
    font-weight: 500;
    margin-right: 8px;
  }

  .add-requirement-type-card-plus-button,
  .add-requirement-type-card-ask-ai-button {
    :deep(.v-icon) {
      --v-icon-size-multiplier: 0.9
    }
  }

  &.add-requirement-type-card-empty {
    padding: 6px 12px;
    margin-bottom: 8px;
    box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.15);

    .add-requirement-type-card-title {
      order: 2;
      margin-left: 8px;
      color: var(--text-dark, #1F2833);
    }

    .add-requirement-type-card-spacer {
      order: 3
    }

    .add-requirement-type-card-plus-button-wrapper {
      order: 1;

      .add-requirement-type-card-plus-button {
        color: var(--light-1, #FCFCFC);
        width: 20px;
        height: 20px;
        font-size: 12px;
      }
    }

    .add-requirement-type-card-ask-ai-button-wrapper {
      order: 4;

      .add-requirement-type-card-ask-ai-button {
        color: var(--text-dark, #1F2833);
      }
    }

  }

  &.add-requirement-type-card-disabled {
    opacity: 0.5;
    cursor: not-allowed;

    :deep(.v-btn) {
      cursor: not-allowed;
      pointer-events: none;
    }
  }
}

.focused {
  animation: pulse 1s forwards;
}

@keyframes pulse {
  0% {
    filter: drop-shadow(0 0 5px rgba(0, 0, 0, 0));
  }
  50%{
    filter: drop-shadow(0 0 5px rgba(0, 0, 0, 0.5));
  }
  100% {
    filter: drop-shadow(0 0 5px rgba(0, 0, 0, 0));
  }
}

.requirement-type-badge {
  font-size: 12px;
  height: 16px;
  margin-top: 5px;
  padding: 2px 5px;
  align-items: flex-start;
  font-weight: 400;
  border-radius: 4px;
}

.requirements-list {
  width: 100%;
}

.create-form {
  border-width: 1px;
  border-top-width: 8px;
  border-style: solid;
}

.column-title + .create-form {
  margin-top: 0 !important;
}

.cards-dialog-content.v-card--link::before {
  display: none;
}

.cards-dialog-content {
  cursor: default;
}
</style>

<style>
.small-font {
  font-size: 12px;
}

.small-font .v-label {
  font-size: 12px;
}
</style>
